import React from 'react';
import Banner from "./Banner"
import ServicesOne from "./ServicesOne"
import WhyChoose from "./WhyChoose"
import Project from "./Project"
import About from './AboutSection';
import Features from './Features';
import Team from './Team';
import WhyareweSec from './WhyAreWeSec';
import Brand from './Brand';
import Blog from './Blog';
import TestimonialsSection from './TestimonialsSection';
import FAQsection from './FAQsection';
import ChairmanMessage from '../../components/About/ChairmanMessage';
import Facilities from './Facilities';
import SunrisingCoursesProgram from './SunrisingCoursesProgram';
// import ReelSection from './ReelSection';



const HomeMain = () => {
	return (
		<React.Fragment>
			<Banner />
			<ServicesOne />
			<WhyChoose />
			<ChairmanMessage />
			<Project />
			<Facilities />
			<Brand />
			<About />
			<SunrisingCoursesProgram/>
			<Features />
			<Team/>
			<WhyareweSec />
			<TestimonialsSection />
			{/* <ReelSection /> */}
			<FAQsection />
			<Blog/>
		</React.Fragment>
	);
}

export default HomeMain;